"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withInvariantState = exports.retry = exports.timeout = exports.onUntil = exports.once = exports.error = exports.doAfter = exports.sleep = exports.emitAckResponse = exports.emitStatusRequestEvent = exports.EBAY_RUM_LOGGER_SYMBOL = exports.EventTypeInlinerAck = exports.EventTypeInlinerStatusRequest = void 0;
exports.assert = assert;
exports.EventTypeInlinerStatusRequest = "@ebay/rum/request-status";
exports.EventTypeInlinerAck = "@ebay/rum/ack-status";
exports.EBAY_RUM_LOGGER_SYMBOL = Symbol.for("@ebay/rum/logger");
function assert(x, message) {
    if (typeof x === "undefined" || Boolean(x) === false || x === null) {
        throw new Error(`[Assertion Error]${message ? ` ${message}` : ``}`);
    }
}
const emitStatusRequestEvent = () => {
    window.dispatchEvent(new CustomEvent(exports.EventTypeInlinerStatusRequest));
};
exports.emitStatusRequestEvent = emitStatusRequestEvent;
const emitAckResponse = (state) => {
    window.dispatchEvent(new CustomEvent(exports.EventTypeInlinerAck, { detail: state }));
};
exports.emitAckResponse = emitAckResponse;
const sleep = (ms) => new Promise((res) => setTimeout(res, ms));
exports.sleep = sleep;
const doAfter = (ms, exec) => (0, exports.sleep)(ms).then(exec);
exports.doAfter = doAfter;
const error = (message) => {
    throw new Error(message);
};
exports.error = error;
const once = (eventType, onEvent) => {
    (0, exports.onUntil)(eventType, (e) => {
        onEvent(e);
        return { done: true, value: null };
    });
};
exports.once = once;
const onUntil = (eventType, onEvent) => {
    window.addEventListener(eventType, function listener(event) {
        const result = onEvent(event);
        if (result.done === true) {
            window.removeEventListener(eventType, listener);
        }
    });
};
exports.onUntil = onUntil;
const timeout = (p, timeoutError, timeoutMs) => Promise.race([p(), (0, exports.doAfter)(timeoutMs, () => (0, exports.error)(timeoutError))]);
exports.timeout = timeout;
const retry = (p, retries) => p().catch((e) => {
    if (retries === 0) {
        throw e;
    }
    return (0, exports.retry)(p, retries - 1);
});
exports.retry = retry;
const withInvariantState = () => {
    let state = null;
    return {
        get value() {
            assert(state !== null, "invariant");
            return state;
        },
        update(next) {
            state = next;
        },
    };
};
exports.withInvariantState = withInvariantState;
